import React from 'react'

export default () => (
    <div className="tn-loader" aria-hidden="true">
        <span className="tn-loader-ring" />
    </div>
)
